import { render, staticRenderFns } from "./NameLookup.vue?vue&type=template&id=6505b457&"
import script from "./NameLookup.vue?vue&type=script&lang=js&"
export * from "./NameLookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports